import { hasPermission as sharedHasPermission, isSuperAdminOrOwner, MODULES } from '@jira-clone/shared-types'

export type Permission = { module: string; actions: string[] }

/**
 * Checks if the user with given permissions and role has access to (module, action).
 * Superadmin or Owner automatically has all permissions.
 */
export function hasPermission(
  permissions: Permission[] | undefined,
  module: string,
  action: string,
  role?: string
): boolean {
  return sharedHasPermission({ role, permissions }, module, action)
}

/**
 * Alias for hasPermission.
 */
export function can(
  permissions: Permission[] | undefined,
  module: string,
  action: string,
  role?: string
): boolean {
  return hasPermission(permissions, module, action, role)
}

/**
 * Returns a list of unique module keys accessible by the user.
 */
export function getVisibleModules(permissions: Permission[] | undefined, role?: string): string[] {
  if (isSuperAdminOrOwner(role)) {
    return Object.values(MODULES)
  }
  const modules = (permissions || []).filter((p) => p.actions && p.actions.length > 0).map((p) => p.module)
  // TIMESHEETS is available to all authenticated employees unless explicitly disabled with empty actions
  const tsEntry = permissions?.find((p) => p.module === MODULES.TIMESHEETS)
  if (!tsEntry || (tsEntry.actions && tsEntry.actions.length > 0)) {
    modules.push(MODULES.TIMESHEETS)
  }
  return Array.from(new Set(modules))
}
